export { registerComponent as registerSlotComponent } from '../../components/builtin/Slot/register'
export { default as Slot } from '../../components/builtin/Slot/Slot'
